/**
 * NDL Category Tabs
 * Vanilla JS Tab-Wechsel für Kategorie-Sektionen
 */
(function () {
  'use strict';

  function initCategoryTabs() {
    var sections = document.querySelectorAll('.ndl_category-tabs');

    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('.ndl_category-tab');
      var productGroups = section.querySelectorAll('.ndl_category-products');
      var scrollEl = section.querySelector('[data-ndl-category-tabs-scroll]');
      var prevButton = section.querySelector('[data-ndl-category-tabs-prev]');
      var nextButton = section.querySelector('[data-ndl-category-tabs-next]');
      var showMore = section.querySelector('[data-ndl-category-show-more]');
      var showMoreLink = section.querySelector('[data-ndl-category-show-more-link]');

      if (tabs.length === 0 || productGroups.length === 0) return;

      function syncShowMoreLink(activeGroup) {
        if (!showMore || !showMoreLink || !activeGroup) return;

        var url = activeGroup.dataset.showMoreUrl;
        var hidden = activeGroup.dataset.showMoreHidden === 'true' || !url;

        showMore.hidden = hidden;
        if (!hidden) {
          showMoreLink.href = url;
        }
      }

      function updateNavButtons() {
        if (!scrollEl || !prevButton || !nextButton) return;

        var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
        var canScroll = maxScroll > 1;

        prevButton.disabled = !canScroll || scrollEl.scrollLeft <= 1;
        nextButton.disabled = !canScroll || scrollEl.scrollLeft >= maxScroll - 1;
      }

      function scrollCapsules(direction) {
        if (!scrollEl) return;

        var distance = Math.max(scrollEl.clientWidth * 0.55, 120);
        scrollEl.scrollBy({
          left: direction * distance,
          behavior: 'smooth'
        });
      }

      if (prevButton && prevButton.dataset.ndlCategoryTabsBound !== 'true') {
        prevButton.addEventListener('click', function () {
          scrollCapsules(-1);
        });
        prevButton.dataset.ndlCategoryTabsBound = 'true';
      }

      if (nextButton && nextButton.dataset.ndlCategoryTabsBound !== 'true') {
        nextButton.addEventListener('click', function () {
          scrollCapsules(1);
        });
        nextButton.dataset.ndlCategoryTabsBound = 'true';
      }

      if (scrollEl && scrollEl.dataset.ndlCategoryTabsBound !== 'true') {
        scrollEl.addEventListener('scroll', updateNavButtons);
        window.addEventListener('resize', updateNavButtons);
        scrollEl.dataset.ndlCategoryTabsBound = 'true';
      }

      updateNavButtons();

      tabs.forEach(function (tab) {
        if (tab.dataset.ndlCategoryTabsBound === 'true') return;

        tab.addEventListener('click', function (e) {
          e.preventDefault();

          var targetId = this.getAttribute('data-target');
          if (!targetId) return;

          // Remove active from all tabs
          tabs.forEach(function (t) {
            t.classList.remove('ndl_active');
          });

          // Hide all product groups
          productGroups.forEach(function (group) {
            group.classList.remove('ndl_active');
          });

          // Set active on clicked tab
          this.classList.add('ndl_active');

          // Show target product group
          var targetGroup = section.querySelector('#' + targetId);
          if (targetGroup) {
            targetGroup.classList.add('ndl_active');
            syncShowMoreLink(targetGroup);
          }

          // Optional: URL-Hash für Deep-Linking
          if (history.replaceState) {
            history.replaceState(null, null, '#' + targetId);
          }
        });

        tab.dataset.ndlCategoryTabsBound = 'true';
      });

      syncShowMoreLink(section.querySelector('.ndl_category-products.ndl_active'));
    });

    // Deep-Link: Aktiviere Tab aus URL-Hash beim Laden
    var hash = window.location.hash;
    if (hash && hash.length > 1) {
      var hashId = hash.substring(1);
      var targetGroup = document.getElementById(hashId);

      if (targetGroup && targetGroup.classList.contains('ndl_category-products')) {
        var parentSection = targetGroup.closest('.ndl_category-tabs');
        if (parentSection) {
          // Deactivate all
          parentSection.querySelectorAll('.ndl_category-tab').forEach(function (t) {
            t.classList.remove('ndl_active');
          });
          parentSection.querySelectorAll('.ndl_category-products').forEach(function (g) {
            g.classList.remove('ndl_active');
          });

          // Activate matching tab
          var matchingTab = parentSection.querySelector('[data-target="' + hashId + '"]');
          if (matchingTab) {
            matchingTab.classList.add('ndl_active');
          }
          targetGroup.classList.add('ndl_active');

          var showMore = parentSection.querySelector('[data-ndl-category-show-more]');
          var showMoreLink = parentSection.querySelector('[data-ndl-category-show-more-link]');
          var url = targetGroup.dataset.showMoreUrl;
          var hidden = targetGroup.dataset.showMoreHidden === 'true' || !url;

          if (showMore && showMoreLink) {
            showMore.hidden = hidden;
            if (!hidden) {
              showMoreLink.href = url;
            }
          }
        }
      }
    }
  }

  // Init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategoryTabs);
  } else {
    initCategoryTabs();
  }

  // Re-init when Shopify section is loaded/rerendered (Theme Editor support)
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.ndl_category-tabs')) {
      initCategoryTabs();
    }
  });
})();
